export default __webpack_public_path__ + "static/media/bottega.0e21b6f3.jpg";